<template>
  <div class="md-layout text-center" style="">
    <notifications></notifications>
    <div
      class="
        md-layout-item
        md-size-100
        md-medium-size-100
        md-small-size-100
        md-xsmall-size-100
      "
    >
      <!--  header-color="blue" -->
      <login-card :selected="selected" @changeLoginType="type => selected = type">
        <!-- 地区选择 -->
        <div class="md-form-group" slot="inputs">
          <md-field class='input-select' style="padding-left: 8px !important;padding-right: 10px !important;">
            <md-select v-model="zone">
              <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                $router.history.current.query.lang === "zh-CN" ?item.cn_name :item.name
              }}</md-option>
            </md-select>
            <div id="zones" @click="$refs.zone.open()" style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"/>
          </md-field>
        </div>
        <!-- 账号( 手机号 | 邮箱 ) -->
        <div class="md-form-group login-type" slot="inputs">
          <div style="display:flex;">
            <div style="width: 30%; margin-right: 1%;" v-if="type === 1">
              <md-field class='input-select' style="padding-left: 8px !important;">
                <md-select v-model="phone_fount">
                  <md-option :value="'+86'">+86</md-option>
                </md-select>
              </md-field>
            </div>
            <md-field class='input-select'>
              <md-input v-model="user" :placeholder='type === 1 ?$I18n("pls_input_phone") :$I18n("pls_input_email")'></md-input>
            </md-field>
          </div>
          <div v-if="zone == 'CN'" class="change-login-type">
            <!-- 手机 -->
            <img v-show="type === 1" @click="type = 2" src="/img/haiqora/Frame_2.png" height="18" width="18">
            <!-- 邮箱 -->
            <img v-show="type === 2" @click="type = 1" src="/img/haiqora/Frame_1.png" height="18" width="18" class="email">
          </div>
        </div>
        <!-- 密码 -->
        <div v-if="selected === 1" class="md-form-group login-type" slot="inputs">
          <img src="/img/haiqora/Lock.png" style="position: absolute; left: 12px;width: 19px; height: 19px;z-index: 1;top: 11px;" />
          <md-field class="input-select" slot="inputs" style="padding-left: 33px !important;">
            <md-input v-model="password" :placeholder="$I18n('pls_input_password')" type="password"></md-input>
          </md-field>
        </div>
        <!-- 前端-验证码 + 按钮 -->
        <div v-if="selected === 1" class="md-form-group login-type" slot="inputs">
          <div style="display: flex;justify-content: space-between;">
            <img src="/img/haiqora/Group.png" style="position: absolute; left: 12px;width: 19px; height: 19px;z-index: 1;top: 11px;" />
            <md-field class='input-select big-placeholder' style="flex:1; padding-left: 33px !important;margin-right: 1% !important;">
              <md-input v-model="input_vcode" :placeholder='$I18n("pls_input_vc_code")'></md-input>
            </md-field>
            <button v-if="vcodeurl == ''" class='input-select click-button' style="width: 135px;" @click="getVCodeImg">
              {{$I18n("click_get")}}
            </button>
            <canvas v-show="vcodeurl !=''" ref="captchaCanvas" width="135" height="39" style="height: 39px; width: 135px;" @click="getVCodeImg"/>
          </div>
        </div>
        <!-- 后端-验证码 + 按钮 -->
        <div v-if="selected === 2" class="md-form-group login-type" slot="inputs">
          <div style="display: flex;justify-content: space-between;">
            <img src="/img/haiqora/Group.png" style="position: absolute; left: 12px;width: 19px; height: 19px;z-index: 1;top: 11px;" />
            <md-field class='input-select big-placeholder' style="width: 64%;padding-left: 33px !important;">
              <md-input v-model="input_vcode" :placeholder='$I18n("pls_input_vc_code")'></md-input>
            </md-field>
            <button class='input-select' style="width: 35%;" @click="api_getVcCode">
              {{countDown > 0 ?(countDown + "s") :$I18n("click_get")}}
            </button>
          </div>
        </div>
        <!-- 4位数验证码图片 -->
        <div v-if="false" class="md-form-group login-type" slot="inputs">
          <!-- <canvas ref="vcode" width="100" height="50" ></canvas> -->
          <img :src="vcodeurl" style="width:auto; height: 39px;">
        </div>
        <div class="footer" slot="footer">
          <button class="diy-submit " @click="submit">
            {{$I18n("login")}}
          </button>
          <div class="diy-footer">
            <div @click="() => $gopage('/register')">{{$I18n("register")}}</div>
            <div @click="() => $gopage('/forgetpw')">{{$I18n("forget_passwd")}}</div>
          </div>
        </div>
      </login-card>
    </div>
    <zone-select-modal ref="zone" @select="new_zone => (zone = new_zone)"/>
    <div style="position: fixed; bottom: 10px;width: 100%;left: 0;right: 0;">
      {{$I18n('the_record_version_num')}}
    </div>
  </div>
</template>
<script>

import { LoginCard } from "@/components";
import {countryArray} from "@/common/continent.js";
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {emailLegal}   from "@/common/tools.js";
/*continentArray*/
export default {
  components: {
    LoginCard,
    ZoneSelectModal,
  },
  created(){
    if(!localStorage._zone){
      if(navigator.language === "zh-CN"){
        localStorage._zone = "CN";
        this.zone = "CN";
      } else {
        localStorage._zone = "US";
        this.zone = "US";
      }
    }
    
    this.$root.state.apiurl = "";
    if(localStorage._zone !== "CN"){
      this.type = 2;
    }
    if(localStorage.__log_type){
      this.type = parseInt(localStorage.__log_type);
      setTimeout(() => {
        this.password = localStorage.__log_pass;
        this.user = localStorage.__log_user;
        delete localStorage.__log_type;
        delete localStorage.__log_pass;
        delete localStorage.__log_user;
      }, 100)
    }
  },
  mounted(){
    this.getVCodeImg();
  },
  data() {
    return {
      countryArray: countryArray,

      selected : 1, // 密码(1)/验证码(2)登录
      type     : 1, // 手机(1)/邮箱(2)登录
      countDown: 0, // 获取验证码冷却

      vcode    : "", // 正确验证码
      input_vcode: "",
      vcodeurl : "", // 验证码CODE的URL

      zone: localStorage._zone?localStorage._zone :"",

      user: "", // 手机|邮箱
      password: "",
      phone_fount: "+86", // 手机号区
    };
  },
  watch:{
    zone(val){
      localStorage._zone = val;
      if(val !== "CN"){
        this.type = 2;
      }
    },
    selected(newValue){
      this.password = "";
      // 重置验证码
      this.input_vcode = "";
      this.countDown = 0;
      if(newValue === 1){
        setTimeout(() => {this.getVCodeImg()}, 0);
      }
    },
    type(){
      this.user = "";
      this.password = "";
      this.input_vcode = "";
      this.countDown = 0;
      if(this.selected === 1){
        // 重置验证码
        this.getVCodeImg();
      }
    },
  },
  methods: {
    // 获取后台验证码
    api_getVcCode(){
      if(this.countDown > 0){
        return
      }
      // 校验 -- 账号
      if(this.type === 2){
        if(!this.user || !emailLegal(this.user) || this.user.length > 128){
          this.$errorMsg(this.$I18n("pls_input_email"), 3000)
          return
        }
      }
      if(this.type === 1 && (!this.user || isNaN(this.user))){
        this.$errorMsg(this.$I18n("pls_input_phone"), 3000)
        return
      }
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(100, window.appConfig.umeye_api(isHttps, window.appConfig.umeye_url), {
        client_id: "web",
        client_type: 6,
        custom_flag: window.appConfig.custom_flag,
        zone : this.zone,
        user_id : this.type === 1 ?this.phone_fount.replace("+","")+this.user :this.user,
      })
        // 请求 201
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          this.$setUserInfo({
            umh_host: res.b.umh_host,
          });
          localStorage.umh_host = res.b.umh_host;

          this.$api.g_VCode({
            link_param  : this.phone_fount.replace("+",""),
            msg_param   : "",
            app_key     : window.appConfig.custom_flag,
            link_id     : this.user,
            notify_type : 10,
            push_type   : this.type === 1 ?3 :2, // 2: 邮件，3: 短信
          })
          .then(this.$Then(() => {
            this.countDown = 120;
            let cd = setInterval(() => {
              if(this.countDown === 1){
                clearInterval(cd);
              }
              this.countDown = this.countDown - 1;
            } , 1000)
            this.$successMsg(this.$I18n("vc_sended"));
          }))
          .catch(this.$Catch(this.$I18n("get_error")));
        })
        .catch(err => {
          if(err.h.e == 406){
            this.$errorMsg(this.$I18n("error_code_406_1"))
          } else {
            this.$errorMsg(this.$I18n("get_error"))
          }
        })
    },
    // 生成指定长度的随机字符串
    generateRandomString(length) {
        var charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var result = '';
        for (var i = 0; i < length; i++) {
            var randomIndex = Math.floor(Math.random() * charset.length);
            result += charset.charAt(randomIndex);
        }
        return result;
    },
    // 获取验证码图片
    getVCodeImg(){
      var canvas = this.$refs.captchaCanvas;
      var ctx = canvas.getContext('2d');

      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 设置背景色
      ctx.fillStyle = '#F5F5F5';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 生成随机验证码字符串
      this.vcode = this.generateRandomString(4);
      this.vcodeurl = this.vcode;
      var captchaText = this.vcode;

      // 设置字体和颜色
      ctx.font = '30px Arial';
      ctx.fillStyle = '#333';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

      // 在画布上绘制验证码文本
      ctx.fillText(captchaText, canvas.width/2, canvas.height/2);

      // 添加噪音线
      for (let i = 0; i < 10; i++) {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        ctx.strokeStyle = `rgb(${r},${g},${b})`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }
    },
    // 登录
    submit (){
      // 校验 -- 账号
      if(this.type === 2){
        if(!this.user || !emailLegal(this.user) || this.user.length > 128){
          this.$errorMsg(this.$I18n("pls_input_email"), 3000)
          return
        }
      }
      if(this.type === 1 && (!this.user || isNaN(this.user))){
        this.$errorMsg(this.$I18n("pls_input_phone"), 3000)
        return
      }
      // 校验 -- 密码
      if(this.selected === 1){
        if(this.password === ""){
          this.$errorMsg(this.$I18n("pls_input_password"), 3000)
          return
        }
        if(this.vcode.toLocaleLowerCase() != this.input_vcode.toLocaleLowerCase() || this.input_vcode === ""){
          this.$errorMsg(this.$I18n("error_vc"), 3000)
          return
        }
      }
      // 校验 -- 验证码
      if(this.selected === 2){
        if(this.input_vcode === ""){
          this.$errorMsg(this.$I18n("vc_none"), 3000)
          return
        }
      }
      // 提交数据
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(100, window.appConfig.umeye_api(isHttps, window.appConfig.umeye_url), {
        client_id: "web",
        client_type: 6,
        custom_flag: window.appConfig.custom_flag,
        user_id : this.type === 1 ?this.phone_fount.replace("+","")+this.user :this.user,
      })
        // 请求 202
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          // 参数筛选
          let ver_type = 0;
          let vcode = this.input_vcode;
          if(this.selected === 1){ // 密码登录
            ver_type = 0;
            vcode = "";
          } else if(this.selected === 2){ // 验证码
            if(this.type === 1){ // 手机
              ver_type = 3;
            } else if(this.type === 2){ // 邮箱
              ver_type = 4;
            }
          }

          this.$setUserInfo({
            umh_host: res.b.umh_host,
          });
          localStorage.umh_host = res.b.umh_host;

          return this.$api.__sendNumApi(202,window.appConfig.umeye_api(isHttps, res.b.umh_host), {
            client_id: "web",
            client_type: 6,
            custom_flag: window.appConfig.custom_flag,
            area_code  : this.type === 1 ?this.phone_fount.replace("+","") :"",
            enc_type   : 2, // 明文
            user_id    : this.type === 1 ?this.phone_fount.replace("+","")+this.user :this.user,
            user_passwd: this.password,
            ver_code   : vcode, // 验证码
            ver_type   : ver_type, // 验证类型 0：密码验证，3：手机短信，4：邮箱短信
          })
        })
        // 处理回调
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          localStorage.acc_token = res.b.access_token;
          this.$setUserInfo({
            ...this.UserInfo,
            ...res.b,
            // login: "phone", 
          })
          this.$successMsg(this.$I18n("log_succ"))
          setTimeout(() => {
            this.$router.push({
              query: { ...this.$router.history.current.query },
              path: "/"
            })
          },1000)
        })
        .catch(res => {
          console.error(res)
          if(res && res.h){
            if(res.h.e == 514){
              this.$errorMsg(this.$I18n("error_code_514_3"), 3000)
            } else if(res.h.e == 406){
              this.$errorMsg(this.$I18n("error_code_406"), 3000)
            } else if(res.h.e == 512){
              this.$errorMsg(this.$I18n("error_code_512"), 3000)
            } else {
              this.$errorMsg(this.$I18n("log_fail"), 3000)
            }
          } else {
            this.$errorMsg(this.$I18n("log_fail"), 3000)
          }
        })
    },
  },
};
</script>

<style scoped>
  .md-layout.text-center{
    width: 587px !important;
    margin-left: auto;
    margin-right: 6vw;
  }
  .click-button{
    cursor: pointer;
  }
  .footer{
    margin-bottom: 49px;
  }
  .diy-footer{
    margin: auto;
    margin-top: 25px;
    width: 440px;
    color: #578EFF;
    display: flex;
    font-size: 20px;
    font-weight: 400;
    justify-content: space-between;
  }
  .diy-footer>div{
    cursor: pointer;
  }
  .diy-submit{
    /*width: calc(90% - 40px);*/
    width: 440px;
    line-height: 69px;
    height: 69px;
    background: #578EFF;
    color: #FFFFFF;
    font-family: Microsoft YaHei;
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    border: none;
    border-radius: 9px;
  }
  .md-form-group{
    width: 440px;
    margin-left : auto;
    margin-right: auto;
    margin-top: 20px;
  }
  .login-type{
    position: relative;
  }
  .change-login-type{
    position: absolute;
    right: 7px;
    top: 4px;
    height: 33px;
    width: 33px;
    border-radius: 50%;
    background: rgb(229,229,229);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .change-login-type img{
    width: 20px;
    height: 20px;
  }
  img.email{
    margin-bottom: 2px;
  }
</style>